import {
  QuestionCircleOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  Popover,
  Radio,
  Row,
} from "antd";

import {
  Title,
  SubText,
  ContentContainer,
  MyCaseSection,
  Container,
  CaseDetailWrapper,
} from "../../../Form.style";

import { useEffect } from "react";

const Step3 = ({ data, setData, onPrev, onNext, itemLayout }) => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    setData(values);
    onNext();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container style={{ textAlign: "left" }}>
      <MyCaseSection>
        <ContentContainer>
          <Title>상대방(임차인) 정보</Title>

          <div style={{ marginTop: 10 }}>
            <SubText style={{ textAlign: "left" }} type="secondary">
              명도소송 대상인 임차인의 정보를 작성해주세요.
            </SubText>
          </div>

          <Divider style={{ marginTop: 10 }} />
          <CaseDetailWrapper>
            <Form
              {...itemLayout.form}
              layout="horizontal"
              onFinish={onFinish}
              initialValues={data}
              form={form}
              style={{
                marginTop: 10,
                marginBottom: 20,
                width: "100%",
                textAlign: "left",
              }}
              requiredMark={false}
            >
              <Form.Item
                label="임차인 이름"
                name={["tenant", "name"]}
                rules={[
                  {
                    required: true,
                    message: "임차인 이름을 입력해주세요",
                  },
                ]}
              >
                <Input placeholder="임차인 이름을 입력하세요" />
              </Form.Item>

              <Form.Item
                label="임차인 연락처"
                name={["tenant", "phone"]}
              >
                <Input placeholder="알고 있는 경우 입력해주세요" />
              </Form.Item>

              <Form.Item
                label={
                  <>
                    주민등록번호 앞자리
                    <Popover
                      content={
                        <div>
                          소장 작성 시 상대방의 주민등록번호 앞자리가
                          <br />
                          필요할 수 있습니다. 알고 계신지 선택해주세요.
                        </div>
                      }
                      placement="bottom"
                      trigger="click"
                    >
                      <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                    </Popover>
                  </>
                }
                name={["tenant", "ssnYn"]}
                rules={[{ required: true, message: "" }]}
              >
                <Radio.Group>
                  <Radio.Button value="y">알고 있음</Radio.Button>
                  <Radio.Button value="n">모름</Radio.Button>
                </Radio.Group>
              </Form.Item>

              <Form.Item
                label={
                  <>
                    현재 거주 상태
                    <Popover
                      content={
                        <div>
                          임차인이 현재 해당 건물에 거주 중인지,
                          <br />
                          퇴거했지만 짐이 남아있는지 등을 선택해주세요.
                        </div>
                      }
                      placement="bottom"
                      trigger="click"
                    >
                      <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                    </Popover>
                  </>
                }
                name={["tenant", "residenceStatus"]}
                rules={[
                  {
                    required: true,
                    message: "거주 상태를 선택해주세요",
                  },
                ]}
              >
                <Radio.Group>
                  <Radio.Button value="living">현재 거주 중</Radio.Button>
                  <Radio.Button value="left_stuff">퇴거(짐 남음)</Radio.Button>
                  <Radio.Button value="unknown">확인 불가</Radio.Button>
                </Radio.Group>
              </Form.Item>

              <Form.Item
                label={
                  <>
                    제3자 거주 여부
                    <Popover
                      content={
                        <div>
                          임차인이 아닌 제3자가 해당 건물에
                          <br />
                          거주하고 있는지 선택해주세요.
                          <br />
                          (점유이전금지 가처분 검토에 필요합니다)
                        </div>
                      }
                      placement="bottom"
                      trigger="click"
                    >
                      <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                    </Popover>
                  </>
                }
                name={["tenant", "thirdPartyOccupant"]}
                rules={[{ required: true, message: "" }]}
              >
                <Radio.Group>
                  <Radio.Button value="y">예</Radio.Button>
                  <Radio.Button value="n">아니오</Radio.Button>
                </Radio.Group>
              </Form.Item>

              <Row justify="space-between">
                <Col span={6}>
                  <Button
                    type="primary"
                    onClick={onPrev}
                    style={{ width: "100%", maxWidth: "100px" }}
                  >
                    이전
                  </Button>
                </Col>
                <Col span={6} offset={10} style={{ textAlign: "right" }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: "100%", maxWidth: "100px" }}
                  >
                    다음
                  </Button>
                </Col>
              </Row>
            </Form>
          </CaseDetailWrapper>
        </ContentContainer>
      </MyCaseSection>
    </Container>
  );
};

export default Step3;
